<template>
    <div class="footer">
        Copyright © {{year}}-{{year}} Allvita Animal Health Pty Ltd, All Rights Reserved.
    </div>
</template>

<script>
export default {
    computed: {
        year() {
            var date = new Date
            return date.getFullYear()
        }
    }
}
</script>

<style scoped lang="scss">
.footer {
    width: 100%;
    height: 2.2rem;
    // position: absolute;
    // z-index: 8;
    // bottom: 0;
    // left: 0;
    background-color: rgba($color: #000000, $alpha: 0.4);
    color: #FFFFFF;
    text-align: center;
    line-height: 2.2rem;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .footer {
        font-size: 0.6rem;
        height: 1.8rem;
        line-height: 1.8rem;
    }
}
    
</style>